import React, { Component } from 'react';
import { Input, Button } from 'reactstrap';
import IconPointer from 'images/icon_pointer.png';

export default class GooglePolicyModal extends Component {
  constructor(props) {
    super(props);
  }
  
  renderMobileContent() {
    const { acceptTerm, onCheckboxChange, onUnderstandClick, goBackToSelect } = this.props;
    
    return (
      <div className="my-2 row justify-content-center mobile-google-container">
        <div className="vl ml-2">
          <div className="ml-2">
            <div className='mb-3 d-flex justify-content-end'>
              <a href="#" className="text-underline font-weight-bold" onClick={goBackToSelect} style={{color:'#575757'}}>1個前に戻る</a>
            </div>
            <div className="p-2 google-additional-info mobile-info">
              <div className='d-flex justify-content-center mb-2'>
                <span className='additional-akaire-title mobile-title'> 【Googleドライブデータをご利用前の確認事項について】 </span>
              </div>
              <span className="mobile-text mt-2" style={{color:'#575757'}}>Googleドライブの各ファイルの右側にある「共有」メニューから、一般的なアクセス権を「<a className="text-underline" style={{color:'#575757'}} target="_blank" href='https://support.google.com/a/users/answer/12380484?hl=ja#link_sharing'>リンクを知っている全員</a>」に設定してください。</span><br/>
              <span className="mobile-text" style={{color: '#575757'}}> さらに、歯車アイコンをクリックし、「<a target="_blank" href="https://support.google.com/a/users/answer/12380484?hl=ja&sjid=16013163274115499572-NC#settings" className="text-underline" style={{color: '#575757'}}>閲覧者および閲覧者（コメント可）に対して、ダウンロード、印刷、コピーのオプションを表示する</a>」にチェックを入れる必要があります。</span><br/>
              <div className='google-instruction mobile-instruction'>
                <span className='ml-n1 mobile-text font-weight-bold text-black'>＜校正可能なデータについて＞</span>
                <div className="mobile-google-policy">
                  <b>動画・PDFデータ：</b>
                  <br/>
                  <span>URLを入力後、「校正する」をクリックすると、自動的にデータがアップロードされます。</span>
                </div>
                <div className="mobile-google-policy">
                  <b>動画・PDFデータの削除について： </b>
                  <br/>
                  <span>Googleドライブ側で動画およびPDFデータを削除すると、</span>
                  <br/>
                  <span>同時に「アップロードした動画およびPDFデータ」も削除可能です。</span>
                </div>
                
                <div className="mobile-google-policy">
                  <b>画像データ：</b>
                  <br/>
                  <span>URLを入力するだけで校正が可能です。</span>
                </div>
                <div className="mobile-google-policy">
                  <b>画像データについて：</b>
                  <br/>
                  <span>アップロードはされません。ダウンロード可否に関わらず、アカポン上にデータは保管されません。</span>
                </div>
                <span className='ml-n1 mobile-text font-weight-bold text-black'>＜校正対象ファイル形式＞</span>
                <br/>
                <div className='mobile-google-policy'>
                  <span>【動画】MP4・MOV・WMV・AVI </span>
                  <br/>
                  <span>【画像・PDF】PDF・PNG・JPG</span>
                </div>
                <span className='ml-n1 mobile-text font-weight-bold text-black'>注意事項（ご利用前に必ずご確認ください）：</span>
                <br/>
                <span className='mobile-text'>Googleドキュメント（Google Docs）および Googleスプレッドシート（Google Sheets）の校正には対応しておりません。</span>
                <br/>
                <span className='mobile-text'>※上記の形式のデータを入力しても、アカポンでは校正機能が動作しませんのでご注意ください。</span>
              </div>
              <img src={IconPointer} className="google-instruction-pointer mobile-pointer" alt="アップロード" width="38" />
            </div>
            <div className='d-flex justify-content-center mt-3'>
              <Button
                className={`bg-dark d-flex align-items-center text-white px-3 py-2 mr-3 large-akaire-button ${!acceptTerm && 'opacity-0_5'}`}
                color="secondary"
                onClick={onCheckboxChange}
              >
                <span style={{marginTop: '3px'}}>内容を確認した</span>
              </Button>
              <Button
                className={`bg-secondary d-flex align-items-center text-white px-3 py-2 large-akaire-button ${!acceptTerm && 'opacity-0_5'}`}
                color="secondary"
                onClick={onUnderstandClick}
              >
                <span style={{marginTop: '3px'}}>後で確認する</span>
              </Button>
            </div> 
            <div className='mt-3 text-center'>
              <span className='mobile-text'>
                <span style={{ marginLeft: window.innerWidth < 466 ? '-59px' : '18px' }}>
                  ※「内容を確認した」を選ぶと、
                </span>
                { window.innerWidth < 466 && <br/>}
                <span>次回以降この確認ページはスキップされます。</span>
              </span>
              <br/>
              <span className='mobile-text'>
                <span style={{ marginLeft: '-70px' }}>
                  ※「後で確認する」を選ぶと、
                </span>
                { window.innerWidth < 466 && <br/>}
                <span style={{ marginLeft: '-38px' }}>引き続きこのページが表示されます。</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderDesktopContent() {
    const { acceptTerm, onCheckboxChange, onUnderstandClick, goBackToSelect } = this.props;
    
    return (
      <div className="my-2 row justify-content-center">
        <div className="vl ml-3">
          <div className="ml-3">
            <div className='mt-2 mr-2 d-flex justify-content-end'>
              <a href="#" className="text-underline font-weight-bold" onClick={goBackToSelect} style={{color:'#575757'}}>1個前に戻る</a>
            </div>
            <div className="mt-2 p-3 google-additional-info">
              <div className='d-flex justify-content-center mb-4'>
                <span className='additional-akaire-title'> 【Googleドライブデータをご利用前の確認事項について】 </span>
              </div>              
              <div className='mx-3 google-instruction'>
                <span>Googleドライブの各ファイルの右側にある「共有」メニューから、一般的なアクセス権を「<a className="text-underline" style={{color:'#575757'}} target="_blank" href='https://support.google.com/a/users/answer/12380484?hl=ja#link_sharing'>リンクを知っている全員</a>」に設定してください。</span><br/>
                <span> さらに、歯車アイコンをクリックし、「<a target="_blank" href="https://support.google.com/a/users/answer/12380484?hl=ja&sjid=16013163274115499572-NC#settings" className="text-underline" style={{color:'#575757'}}>閲覧者および閲覧者（コメント可）に対して、ダウンロード、印刷、コピーのオプションを表示する</a>」にチェックを入れる必要があります。</span><br/>
                <span className='text-black font-weight-bold mt-3'>＜校正可能なデータについて＞</span>
                <div className='ml-2 google-instruction'>
                  <span><b>動画・PDFデータ：</b>URLを入力後、「校正する」をクリックすると、自動的にデータがアップロードされます。</span><br/>
                  <span><b>動画・PDFデータの削除について：</b>Googleドライブ側で動画およびPDFデータを削除すると、同時に「アップロードした動画およびPDFデータ」も削除可能です。</span><br/>
                  <span>※ 削除時のアクションについては、各データごとに設定でき、後から変更も可能です。</span><br/>
                  <span><b>画像データ：</b>URLを入力するだけで校正が可能です。</span><br/>
                  <span><b>画像データについて：</b>アップロードはされません。ダウンロード可否に関わらず、アカポン上にデータは保管されません。</span><br/>
                  <span className='font-weight-bold mt-2 text-black'>＜校正対象ファイル形式＞</span>
                  <div className='font-weight-bold'>
                    <span>【動画】MP4・MOV・WMV・AVI</span><br/>
                    <span>【画像・PDF】PDF・PNG・JPG</span>
                  </div>
                  <span className='font-weight-bold mt-3 text-black'>注意事項（ご利用前に必ずご確認ください）：</span>
                  <br/>
                  <span className="fs-14">Googleドキュメント（Google Docs）および Googleスプレッドシート（Google Sheets）の校正には対応しておりません。</span>
                  <br/>
                  <span className="fs-14">※上記の形式のデータを入力しても、アカポンでは校正機能が動作しませんのでご注意ください。</span>
                </div>
                <img src={IconPointer} className="google-instruction-pointer" alt="アップロード" width="48" />
              </div>
            </div>
            <div className='d-flex justify-content-center mt-3'>
              <Button
                className={`bg-dark d-flex align-items-center text-white px-5 py-2 mr-3 large-akaire-button ${!acceptTerm && 'opacity-0_5'}`}
                color="secondary"
                onClick={onCheckboxChange}
              >
                <span>内容を確認した</span>
              </Button>
              <Button
                className={`bg-secondary d-flex align-items-center text-white px-5 py-2 large-akaire-button ${!acceptTerm && 'opacity-0_5'}`}
                color="secondary"
                onClick={onUnderstandClick}
              >
                <span>後で確認する</span>
              </Button>
            </div>
            <div className='mt-3 text-center'>
              <span className='fs-14' style={{ marginLeft: '115px' }}>※「内容を確認した」を選ぶと、次回以降この確認ページはスキップされます。</span>
              <br/>
              <span className='fs-14' style={{ marginLeft: '46px' }}>※「後で確認する」を選ぶと、引き続きこのページが表示されます。</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { isMobile } = this.props;
    return isMobile ? this.renderMobileContent() : this.renderDesktopContent();
  }
}
